import React from 'react';
import Items from '../Items';
import { LessonBlock } from '../types';

// The visible heading is setupTitle, rendered at card-title size. `block.title`
// is metadata here and must stay unrendered or the card gets two headings.
export default function ContentCard({ block }: { block: LessonBlock }) {
  return (
    <>
      {block.setupTitle && <h2 className="pc-lesson-card-title">{block.setupTitle}</h2>}
      {block.headerImageEl && (
        <img
          className="pc-lesson-card-img"
          src={block.headerImageEl.src}
          alt={block.headerImageEl.alt}
        />
      )}
      <Items items={block.contentItems || []} />
    </>
  );
}
